import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Divider,
  Button,
  Card,
  CardContent,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  Tabs,
  Tab,
  Stack,
} from "@mui/material";
import {
  FolderOpen,
  EmailOutlined,
  Assignment,
  Person,
  FactCheck,
  Event,
  Translate,
  SupportAgent,
  Comment,
  Payment,
  WorkOutline,
} from "@mui/icons-material";
import dayjs from "dayjs";
import GenericTable from "../../Components/Ui_elements/GenericTable";
import { useDispatch, useSelector } from "react-redux";
import {
  acceptJobStatus,
  jobSummeryDetailsGet,
  jobSummeryWorkinstructUpdate,
  rejectJobStatus,
  sendjobResourceMsg,
} from "../../redux/Thunk/FreelanceScreenThunk/FreelanceThunk";
import Btn from "../../Components/Ui_elements/Btn";
import PopupModal from "../../Components/Ui_elements/PopupModal";
import { set } from "lodash";
import TextFieldComponent from "../../Components/TextFieldComponent";
import JobRejectModal from "../../Components/JobRejectModal";
import JobdiscussionComponent from "../../Components/JobdiscussionComponent";
import EmailClient from "../Admin/A_System/Templates/EmailClient";
import { getJobSourceTragetFilesTotal } from "../../redux/Thunk/DashboardModule/DashboardThunk";
import JobFolderDownloadTrigger from "../../Components/JobFolderDownloadTrigger";
import { formatDate, localizeNumber } from "../../Helper/generalhelper";
import { getCenteredPopupSize } from "../../Helper/Constants";
import { showSnackbar } from "../../redux/Slice/snackbar/snackbarSlice";

const JobsPopup = ({
  openFromReport = false,
  chatData,
  data,
  isChatOpen = false,
  jobId,
  tabValue,
  openJob,
  handleOpenJobDiscussionPage,
  onRefresh,
}) => {
  const dispatch = useDispatch();
  const { user } = useSelector(state => state?.root?.authUser);
  const [openAccept, setOpenAccept] = useState(false);
  const [openComplete, setOpenComplete] = useState(false);
  const [openStart, setOpenStart] = useState(false);
  const [isRejeact, setIsReject] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [workInstructions, setWorkInstructions] = useState([]);
  const [currentTab, setCurrentTab] = useState(0); // 0 for Job Details, 1 for Discussion
  const [openJobDisucussion, setOpenJobDisucssion] = useState(false);
  const [openEmail, setOpenEmail] = useState(false);
  const emailRef = useRef();
  const [fileManagerCounts, setSetFileManagerCounts] = useState({ in_count: 0, out_count: 0 });
  const [fileManagerFolderIds, setFileManagerFolderIds] = useState({
    in_fmanager_id: null,
    out_fmanager_id: null,
  });
  const { width, height, left, top } = getCenteredPopupSize(0.5, 0.75);
  const [confirmWork, setConfirmWork] = useState(null);
  const [isRejectSubmitting, setIsRejectSubmitting] = useState(false);
  const [actionState, setActionState] = useState({ isRejected: false, isAccepted: false });

  useEffect(() => {
    setCurrentTab(isChatOpen ? 1 : 0);
  }, [isChatOpen]);

  useEffect(() => {
    const raw = data?.work_instruction;
    try {
      const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
      if (Array.isArray(parsed)) {
        setWorkInstructions(
          parsed.map((item, index) => ({
            work_id: item?.work_id ?? index,
            work_name: item?.work_name || "",
            work_checked: !!item?.work_checked,
          }))
        );
      } else {
        setWorkInstructions([]);
      }
    } catch (err) {
      console.error("Failed to parse work_instruction on update:", err);
      setWorkInstructions([]);
    }
  }, [data?.work_instruction]);

  useEffect(() => {
    const fetchAndSetFileCounts = async () => {
      if (!data?.job_summmeryId) return;
      dispatch(getJobSourceTragetFilesTotal(data?.job_summmeryId)).then(res => {
        const totals = res?.payload?.data?.[0] || {};
        setSetFileManagerCounts({
          in_count: totals?.in_count ?? 0,
          out_count: totals?.out_count ?? 0,
        });
        setFileManagerFolderIds({
          in_fmanager_id: totals?.in_fmanager_id ?? null,
          out_fmanager_id: totals?.out_fmanager_id ?? null,
        });
      });
    };
    // ✅ Call on first load
    fetchAndSetFileCounts();

    // ✅ Also expose to popup
    window.refreshFileManagerCount = fetchAndSetFileCounts;
  }, [data?.job_summmeryId]);

  useEffect(() => {
    const currentUserId = Number(user?.iUserId);
    const acceptedBy = Number(data?.accept);
    const resourceId = Number(data?.resource);
    const isPoSent = Number(data?.isPoSent) === 1;
    const rejectedIds = String(data?.request_rejected_ids || "")
      .split(",")
      .map(v => Number(v.trim()))
      .filter(v => Number.isFinite(v) && v > 0);
    const sendRequestIds = String(data?.send_request || "")
      .split(",")
      .map(v => Number(v.trim()))
      .filter(v => Number.isFinite(v) && v > 0);

    const wasRejectedByUser = rejectedIds.includes(currentUserId);
    const rejectionOverridden =
      (resourceId === currentUserId && isPoSent) ||
      (data?.item_status === "Requested" && sendRequestIds.includes(currentUserId));

    setActionState({
      isRejected:
        (wasRejectedByUser && !rejectionOverridden) || data?.item_status === "Rejected",
      isAccepted: acceptedBy > 0 && acceptedBy === currentUserId,
    });
  }, [
    data?.accept,
    data?.item_status,
    data?.request_rejected_ids,
    data?.resource,
    data?.isPoSent,
    data?.send_request,
    user?.iUserId,
  ]);

  const handleCheckboxChange = (instruction) => {
    setConfirmWork({
      work_id: instruction.work_id,
      nextValue: !instruction.work_checked,
    });
  };
  const confirmWorkUpdate = () => {
    if (!confirmWork) return;
    const updated = workInstructions.map(item =>
      item.work_id === confirmWork.work_id
        ? { ...item, work_checked: confirmWork.nextValue }
        : item
    );
    setWorkInstructions(updated);
    dispatch(
      jobSummeryWorkinstructUpdate({
        id: jobId,
        payload: updated,
      })
    )
      .unwrap()
      .then(() => {
        dispatch(
          showSnackbar({
            message: "Work instruction updated successfully",
            type: "success",
          })
        );
      })
      .catch(() => {
        dispatch(
          showSnackbar({
            message: "Failed to update work instruction",
            type: "error",
          })
        );
      });

    setConfirmWork(null);
  };

  const rawItemLanguage = data?.ItemLanguage || "";
  const rawPrice = (() => {
    try {
      if (typeof data?.price === "string") {
        return JSON.parse(data.price);
      } else if (typeof data?.price === "object") {
        return data.price;
      } else {
        return [];
      }
    } catch (e) {
      console.error("Failed to parse price:", e);
      return [];
    }
  })();

  let formattedLanguage = "";

  try {
    if (rawItemLanguage && rawItemLanguage.includes("{")) {
      const parts = rawItemLanguage
        .split(/}>\s*{/)
        .map((part, index, arr) => {
          if (!part.trim()) return null;

          if (index !== 0) part = "{" + part;
          if (index !== arr.length - 1) part = part + "}";

          return JSON.parse(part);
        })
        .filter(Boolean);

      formattedLanguage = parts
        .map(p => p.sourceLang)
        .filter(Boolean)
        .join(" > ");
    }
  } catch (e) {
    console.warn("Failed to parse ItemLanguage:", rawItemLanguage);
  }

  const columns = [
    { name: "quantity", label: "Quantity", options: { sort: false } },
    { name: "pricelist", label: "Price Unit", options: { sort: false } },
    { name: "itemPrice", label: "Unit Price", options: { sort: false } },
    {
      name: "itemTotal",
      label: `Amount in ${user?.freelance_currency?.split(",")[0]}  ${localizeNumber(data?.total_price ?? 0)} `,
      sort: false,
      options: {
        customBodyRender: (value, tableMeta) => {
          return localizeNumber(Number(value));
        },
      },
    },
  ];

  const handleAccept = jobType => {
    const payload = {
      ...(jobType === "accept" && { acceptJobType: jobType }),
      item_status: "Ongoing",
      userId: user?.iUserId,
    };
    dispatch(acceptJobStatus({ id: jobId, payload: payload })).then(response => {
      setOpenAccept(false);
      setOpenStart(false);
      dispatch(jobSummeryDetailsGet(data?.job_summmeryId));
      if (onRefresh) onRefresh();
    });
  };
  const handleCompleted = () => {
    const payload = {
      item_status: "Completed",
    };
    dispatch(acceptJobStatus({ id: jobId, payload: payload })).then(response => {
      setOpenComplete(false);
      dispatch(jobSummeryDetailsGet(data?.job_summmeryId));
      if (onRefresh) onRefresh();
    });
  };
  const handleReject = async () => {
    const trimmed = (rejectReason || "").trim();
    if (!trimmed) return;
    const payload = {
      rejection: trimmed,
      userId: user?.iUserId,
    };
    setIsRejectSubmitting(true);
    try {
      const response = await dispatch(rejectJobStatus({ id: jobId, payload: payload })).unwrap();
      if (response?.status === 200) {
        setActionState(prev => ({ ...prev, isRejected: true }));
        setIsReject(false);
        setRejectReason("");
        dispatch(jobSummeryDetailsGet(data?.job_summmeryId));
        if (onRefresh) onRefresh();
        handleOpenJobDiscussionPage(false);
      }
    } finally {
      setIsRejectSubmitting(false);
    }
  };
  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const handleSubmitMail = async () => {
    if (emailRef.current && emailRef.current.handleSubmit) {
      try {
        const response = await emailRef.current.handleSubmit();
        if (response !== null) {
          // Add vUserName to payload
          const payload = {
            ...response,
            data: {
              ...response.data,
              vUserName: data?.contactPerson,
            },
          };
          dispatch(sendjobResourceMsg(payload));
          setOpenEmail(false); // Close modal on success
        }
      } catch (error) {
        console.error("Failed to send email:", error);
      }
    } else {
      console.error("Email ref or handleSubmit not available");
    }
  };


  return (
    <>
      {openJob && (
        <PopupModal
          disableOverflow={true}
          open={openJob}
          maxWidth="lg"
          title="Jobs"
          handleClose={() => handleOpenJobDiscussionPage(false)}
          actions={
            <>
              {/* <Btn onClick={handleSubmitMail}>Send Mail</Btn> */}
              <Btn variant="outlined" onClick={() => handleOpenJobDiscussionPage(false)}>
                Close
              </Btn>
            </>
          }
        >
          {!openFromReport && (
            <Tabs value={currentTab} onChange={handleTabChange} sx={{ ml: 3 }}>
              <Tab label="Job Details" sx={{ textTransform: "none" }} />
              <Tab label="Discussion" sx={{ textTransform: "none" }} />
            </Tabs>
          )}
          {currentTab === 0 ? (
            <Box sx={{ backgroundColor: "#f8f9fd", p: 3, borderRadius: 2 }}>
              <Box>
                {/* Header Information Cards */}
                <Grid container spacing={3}>
                  {/* Basic Job Details */}
                  <Grid item xs={12} md={5}>
                    <Card
                      sx={{
                        height: "100%",
                        borderRadius: 3,
                        boxShadow: "0 2px 12px 0 rgba(0,0,0,0.04)",
                        border: "1px solid #edf0f5",
                      }}
                    >
                      <CardContent>
                        <Typography
                          variant="overline"
                          color="text.secondary"
                          fontWeight={700}
                          gutterBottom
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Assignment sx={{ fontSize: 16 }} /> Job Details
                        </Typography>
                        <Stack spacing={1.5} mt={1}>
                          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Typography variant="body2" color="text.secondary">Number:</Typography>
                            <Typography variant="body2" fontWeight={600}>{data?.po_number || "—"}</Typography>
                          </Box>
                          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Typography variant="body2" color="text.secondary">Resource:</Typography>
                            <Typography variant="body2" fontWeight={600}>{data?.userName || "—"}</Typography>
                          </Box>
                          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Typography variant="body2" color="text.secondary">Status:</Typography>
                            <Box
                              sx={{
                                px: 1,
                                py: 0.2,
                                borderRadius: 1,
                                bgcolor: data?.item_status === "Ongoing" ? "#e3f2fd" : "#f5f5f5",
                                color: data?.item_status === "Ongoing" ? "#1976d2" : "inherit",
                                fontSize: "0.75rem",
                                fontWeight: 700,
                              }}
                            >
                              {data?.item_status || "—"}
                            </Box>
                          </Box>
                          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Typography variant="body2" color="text.secondary">Due Date:</Typography>
                            <Typography variant="body2" fontWeight={600} color="error.main">
                              {data?.due_date && data.due_date !== "0000-00-00 00:00:00" &&
                                dayjs(data.due_date).isValid()
                                ? formatDate(data.due_date, { formatId: 1,includeTime: true})
                                : "—"}
                            </Typography>
                          </Box>
                        </Stack>
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* Project Information */}
                  <Grid item xs={12} md={6}>
                    <Card
                      sx={{
                        height: "100%",
                        borderRadius: 3,
                        boxShadow: "0 2px 12px 0 rgba(0,0,0,0.04)",
                        border: "1px solid #edf0f5",
                      }}
                    >
                      <CardContent>
                        <Typography
                          variant="overline"
                          color="text.secondary"
                          fontWeight={700}
                          gutterBottom
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <SupportAgent sx={{ fontSize: 16 }} /> Project Info
                        </Typography>
                        <Stack spacing={1.5} mt={1}>
                          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Typography variant="body2" color="text.secondary">Created:</Typography>
                            <Typography variant="body2" fontWeight={600}>
                              {data?.created_date ? dayjs(data.created_date).format("DD.MM.YYYY") : "—"}
                            </Typography>
                          </Box>
                          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: 'center' }}>
                            <Typography variant="body2" color="text.secondary">Language:</Typography>
                            <Typography variant="body2" fontWeight={600} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              <Translate sx={{ fontSize: 14, color: 'primary.main' }} /> {formattedLanguage || "—"}
                            </Typography>
                          </Box>
                          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Typography variant="body2" color="text.secondary">Manager:</Typography>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <Typography variant="body2" fontWeight={600}>{data?.contactPerson || "—"}</Typography>
                              <IconButton
                                size="small"
                                onClick={() =>
                                  (window.location.href = `mailto:${data?.contactPersonEmail}?subject=${data?.po_number || ""}`)
                                }
                                sx={{ ml: 0.5, p: 0.5 }}
                              >
                                <EmailOutlined sx={{ fontSize: 16, color: "primary.main" }} />
                              </IconButton>
                            </Box>
                          </Box>
                        </Stack>
                      </CardContent>
                    </Card>
                  </Grid>


                </Grid>

                {/* File Manager Buttons */}
                <Box mt={3} mb={3}>
                  <Stack direction="row" spacing={2}>
                    <JobFolderDownloadTrigger
                      folderId={fileManagerFolderIds.out_fmanager_id}
                      jobName={data?.po_number}
                    >
                      <Button
                        variant="contained"
                        disableElevation
                        sx={{
                          borderRadius: 2,
                          textTransform: "none",
                          px: 3,
                          bgcolor: "#6366f1",
                          "&:hover": { bgcolor: "#4f46e5" },
                        }}
                        onClick={() =>
                          window.open(
                            `/filemanage/item?jobId=${jobId}&sourceTargetType=_out`,
                            "FileManagerPopup",
                            `width=${width},height=${height},top=${top},left=${left},` +
                            "menubar=no,toolbar=no,location=no,status=no,scrollbars=yes,resizable=yes"
                          )
                        }
                      >
                        <FolderOpen sx={{ fontSize: 18, mr: 1 }} />
                        Deliverables ({fileManagerCounts?.out_count ?? 0})
                      </Button>
                    </JobFolderDownloadTrigger>

                    <JobFolderDownloadTrigger
                      folderId={fileManagerFolderIds.in_fmanager_id}
                      jobName={data?.po_number}
                    >
                      <Button
                        variant="outlined"
                        sx={{
                          borderRadius: 2,
                          textTransform: "none",
                          px: 3,
                          borderColor: "#6366f1",
                          color: "#6366f1",
                          "&:hover": { borderColor: "#4f46e5", bgcolor: "#f5f6ff" },
                        }}
                        onClick={() =>
                          window.open(
                            `/filemanage/item?jobId=${jobId}&sourceTargetType=_in`,
                            "FileManagerPopup",
                            `width=${width},height=${height},top=${top},left=${left},` +
                            "menubar=no,toolbar=no,location=no,status=no,scrollbars=yes,resizable=yes"
                          )
                        }
                      >
                        <FolderOpen sx={{ fontSize: 18, mr: 1 }} />
                        References ({fileManagerCounts?.in_count ?? 0})
                      </Button>
                    </JobFolderDownloadTrigger>
                  </Stack>
                </Box>

                {/* Main Content Area: Comment  */}
                <Grid container spacing={3}>
                  {/* Comment Section - Central and Most Visible */}
                  <Grid item xs={12} md={8}>
                    <Card
                      sx={{
                        borderRadius: 3,
                        boxShadow: "0 4px 20px 0 rgba(0,0,0,0.05)",
                        border: "2px solid #ebf0ff",
                        height: "100%",
                        bgcolor: "#fff",
                      }}
                    >
                      <CardContent>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
                          <Comment sx={{ color: "primary.main" }} />
                          <Typography variant="h6" fontWeight={700}>
                            Comment / Instructions
                          </Typography>
                        </Box>
                        <Divider sx={{ mb: 2 }} />
                        <Typography
                          variant="body1"
                          sx={{
                            whiteSpace: "pre-line",
                            color: "text.primary",
                            lineHeight: 1.7,
                            p: 2,
                            bgcolor: "#fcfdff",
                            borderRadius: 2,
                            border: "1px solid #f0f4ff",
                            minHeight: "150px"
                          }}
                        >
                          {data?.jobDesc || <span style={{ color: '#aaa', fontStyle: 'italic' }}>No comments provided for this job.</span>}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* Compact Job action (Relocated here as requested) */}
                  <Grid item xs={12} md={4}>
                    <Card
                      sx={{
                        borderRadius: 3,
                        boxShadow: "0 2px 12px 0 rgba(0,0,0,0.04)",
                        border: "1px solid #edf0f5",
                        height: "100%",
                      }}
                    >
                      <CardContent>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
                          <FactCheck sx={{ color: "success.main" }} />
                          <Typography variant="h6" fontWeight={700}>
                            Job Action
                          </Typography>
                        </Box>
                        <Divider sx={{ mb: 2 }} />
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                          {data?.item_status === "Requested" && !actionState.isRejected && !actionState.isAccepted && (
                            <>
                              <Button
                                variant="contained"
                                fullWidth
                                size="large"
                                sx={{
                                  bgcolor: "#8b5cf6",
                                  borderRadius: 2,
                                  fontWeight: 600,
                                  "&:hover": { bgcolor: "#7c3aed" },
                                }}
                                onClick={() => setOpenAccept(true)}
                              >
                                Accept Job
                              </Button>

                              <Button
                                variant="outlined"
                                fullWidth
                                color="error"
                                size="large"
                                sx={{ borderRadius: 2, fontWeight: 600 }}
                                onClick={() => setIsReject(true)}
                              >
                                Reject Job
                              </Button>
                            </>
                          )}
                          {actionState.isRejected && (
                            <Typography variant="body2" color="error.main" align="center" sx={{ py: 1, fontWeight: 600 }}>
                              Job Rejected
                            </Typography>
                          )}
                          {(data?.item_status === "In-progress" || data?.item_status === "Ongoing") && (
                            <Button
                              variant="contained"
                              fullWidth
                              size="large"
                              color="success"
                              sx={{ borderRadius: 2, fontWeight: 600 }}
                              onClick={() => setOpenComplete(true)}
                            >
                              Complete Job
                            </Button>
                          )}
                          {(data?.item_status === "Assigned-waiting" || data?.item_status === "Waiting") && (
                            <Button
                              variant="contained"
                              fullWidth
                              size="large"
                              sx={{
                                bgcolor: "#8b5cf6",
                                borderRadius: 2,
                                fontWeight: 600,
                                "&:hover": { bgcolor: "#7c3aed" },
                              }}
                              onClick={() => setOpenStart(true)}
                            >
                              Start Job
                            </Button>
                          )}
                          {/* If no action is available for current status */}
                          {!["Requested", "In-progress", "Ongoing", "Assigned-waiting", "Waiting"].includes(data?.item_status) && (
                            <Typography variant="body2" color="text.secondary" align="center" sx={{ fontStyle: 'italic', py: 2 }}>
                              No further actions required for current status.
                            </Typography>
                          )}
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                  {/* Work instruction Section */}
                  <Grid item xs={12} md={4}>
                    {/* <Card
                      sx={{
                        height: "100%",
                        borderRadius: 3,
                        boxShadow: "0 2px 12px 0 rgba(0,0,0,0.04)",
                        border: "1px solid #edf0f5",
                        bgcolor: "#fafafa"
                      }}
                    >
                      <CardContent sx={{ p: "16px !important" }}>
                        <Typography
                          variant="overline"
                          color="text.secondary"
                          fontWeight={700}
                          sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}
                        >
                          <WorkOutline sx={{ fontSize: 16 }} /> Work Instructions
                        </Typography>
                        <Box
                          sx={{
                            maxHeight: 120,
                            overflowY: "auto",
                            border: "1px solid #eee",
                            borderRadius: 2,
                            bgcolor: "#fff",
                          }}
                        >
                          <Table size="small" stickyHeader>
                            <TableBody>
                              {workInstructions.length > 0 ? (
                                workInstructions.map(instruction => (
                                  <TableRow key={instruction.work_id} hover>
                                    <TableCell sx={{ py: 0.5, borderBottom: "1px solid #f0f0f0", fontSize: '0.75rem' }}>
                                      {instruction.work_name}
                                    </TableCell>
                                    <TableCell align="right" sx={{ py: 0.5, borderBottom: "1px solid #f0f0f0" }}>
                                      <Checkbox
                                        size="small"
                                        checked={instruction.work_checked}
                                        onChange={() => handleCheckboxChange(instruction)}
                                        sx={{ p: 0 }}
                                      />
                                    </TableCell>
                                  </TableRow>
                                ))
                              ) : (
                                <TableRow>
                                  <TableCell align="center" sx={{ py: 2, color: "text.disabled", fontSize: '0.75rem' }}>
                                    No instructions
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </Box>
                      </CardContent>
                    </Card> */}
                  </Grid>
                </Grid>

                {/* Financial Details Table */}
                <Box mt={4}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                    <Payment sx={{ color: "text.secondary" }} />
                    <Typography variant="subtitle1" fontWeight={700}>
                      Payment Details
                    </Typography>
                  </Box>
                  <Card sx={{ borderRadius: 3, overflow: "hidden", border: "1px solid #edf0f5" }}>
                    <GenericTable
                      columns={columns}
                      data={
                        rawPrice?.map((row, index) => ({
                          ...row,
                          rowNumber: index + 1,
                        })) || []
                      }
                      showAction={false}
                      displayColumns={4}
                      displayRows={100}
                      showSearchBox={false}
                      showPagination={false}
                      options={{ sort: false }}
                    />
                  </Card>
                </Box>
              </Box>
              {openAccept && (
                <PopupModal
                  open={openAccept}
                  maxWidth="sm"
                  width="650px"
                  title="Job Request"
                  handleClose={() => setOpenAccept(false)}
                  actions={
                    <>
                      <Btn onClick={() => handleAccept("accept")}>Yes</Btn>
                      <Btn variant="outlined" onClick={() => setOpenAccept(false)}>
                        Close
                      </Btn>
                    </>
                  }
                >
                  <Typography variant="body2">Are you sure you want to accept this job?</Typography>
                </PopupModal>
              )}
              <JobRejectModal
                open={isRejeact}
                title="Job Request"
                reason={rejectReason}
                onChangeReason={e => setRejectReason(e.target.value)}
                onConfirm={handleReject}
                onClose={() => setIsReject(false)}
                isSubmitting={isRejectSubmitting}
              />
              {openComplete && (
                <PopupModal
                  open={openComplete}
                  maxWidth="sm"
                  width="650px"
                  title="Confirm"
                  handleClose={() => setOpenComplete(false)}
                  actions={
                    <>
                      <Btn onClick={handleCompleted}>Yes</Btn>
                      <Btn variant="outlined" onClick={() => setOpenComplete(false)}>
                        Cancel
                      </Btn>
                    </>
                  }
                >
                  <Typography variant="body2">Are you sure you want to mark this job as completed?</Typography>
                </PopupModal>
              )}
              {openStart && (
                <PopupModal
                  open={openStart}
                  maxWidth="sm"
                  width="650px"
                  title="Confirm"
                  handleClose={() => setOpenStart(false)}
                  actions={
                    <>
                      <Btn onClick={() => handleAccept("start")}>Yes</Btn>
                      <Btn variant="outlined" onClick={() => setOpenStart(false)}>
                        Cancel
                      </Btn>
                    </>
                  }
                >
                  <Typography variant="body2">Are you sure you want to start this job?</Typography>
                </PopupModal>
              )}
            </Box>
          ) : (
            <JobdiscussionComponent
              openJobDisucussion={openJobDisucussion}
              jobData={chatData || {}}
              handleOpenJobDiscussionPage={data => setOpenJobDisucssion(data)}
              showFromFreelance={true}
            />
          )}
        </PopupModal>
      )}

      {openEmail && (
        <PopupModal
          open={openEmail}
          maxWidth="lg"
          title="Mail"
          handleClose={() => setOpenEmail(false)}
          actions={
            <>
              <Btn onClick={handleSubmitMail}>Send Mail</Btn>
              <Btn variant="outlined" onClick={() => setOpenEmail(false)}>
                Cancel
              </Btn>
            </>
          }
        >
          <Typography variant="body1">
            <EmailClient
              ref={emailRef}
              general={true}
              userName={data?.userName}
              invoiceNumber={data?.po_number}
              email={data?.contactPersonEmail || ""}
              showFromProfile={true}
            />
          </Typography>
        </PopupModal>
      )}
      {confirmWork && (
        <PopupModal
          open={true}
          maxWidth="xs"
          size="sm"
          width="450px"
          title="Confirm"
          handleClose={() => setConfirmWork(null)}
          actions={
            <>
              <Btn onClick={confirmWorkUpdate}>Yes</Btn>
              <Btn variant="outlined" onClick={() => setConfirmWork(null)}>
                Cancel
              </Btn>
            </>
          }
        >
          <Typography variant="body2">
            Are you sure you want to update this work instruction?
          </Typography>
        </PopupModal>
      )}

    </>
  );
};

export default JobsPopup;
